import { ComingSoonIcon } from '@sketchnote/icons';
import Tippy from '@tippyjs/react';
import React from 'react';

export const ComingSoonTag = (): JSX.Element => {
  return (
    <div className="text-white py-4 px-6 flex bg-green-800 rounded-sm text-xs w-107 font-semibold">
      <ComingSoonIcon wrapperClass="mt-2" />
      <span>Coming soon</span>
    </div>
  );
};

export const ComingSoonIconOnly = () => {
  return (
    <Tippy content="Coming Soon" className="w-auto h-auto bg-gray-999" arrow={true}>
      <span className="inline-block">
        <ComingSoonIcon className="mt-4" />
      </span>
    </Tippy>
  );
};
